export default class QueryString {
    private readonly url: string = '';
    private readonly queryString: string = '';
    private readonly params: Record<string, string | undefined> = {};

    constructor(url: string) {
        if (url) {
            const splitUrl = url.split('?');

            this.url = splitUrl[0];

            if (splitUrl[1]) {
                this.queryString = splitUrl[1];
                this.params = QueryString.parse(this.queryString);
            }
        }
    }

    public getUrl() {
        return this.url;
    }

    public getFullUrl() {
        const queryString = this.getQueryString();

        return this.getUrl() + (queryString ? '?' : '') + queryString;
    }

    public getParams() {
        return this.params;
    }

    public getParam(param: string) {
        return this.params[param] || undefined;
    }

    public getQueryString() {
        return QueryString.stringify(this.params);
    }

    public setParam(param: string, value: string) {
        this.params[param] = value;
    }

    static parse(queryString: string) {
        const hashes = queryString.split('&');

        return hashes.reduce((acc, hash) => {
            const [key, val] = hash.split('=');

            return {
                ...acc,
                [key]: decodeURIComponent(val),
            };
        }, {});
    }

    static stringify(params: Record<string, any>) {
        return Object.keys(params)
            .map((key) => {
                const value = params[key];

                if (value === undefined) {
                    return '';
                }

                if (value === null) {
                    return encodeURIComponent(key);
                }

                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            })
            .join('&');
    }
}
